var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79848 12C5.44394 12 5.08568 11.8597 4.81466 11.5773L0.407912 7.01805C-0.135971 6.45511 -0.135971 5.54441 0.407912 4.98147C0.951795 4.41852 1.83166 4.41852 2.37554 4.98147L5.79848 8.52051L13.6245 0.422207C14.1683 -0.140736 15.0482 -0.140736 15.5921 0.422207C16.136 0.98515 16.136 1.89585 15.5921 2.45879L6.7823 11.5773C6.51128 11.8597 6.15488 12 5.79848 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyTick);
export default __webpack_public_path__ + "static/media/why-tick.96f0ee4755243bce54bdf7ca7646d3fa.svg";
export { ForwardRef as ReactComponent };